<template>
    <tr :id="'row-'+data[model.idProperty]" :row="data[model.idProperty]">
        <td class="uk-background-muted uk-text-center">
            <input :checked="selected" class="uk-checkbox" type="checkbox" v-on:change="selectChange()">
        </td>
        <TableColumnData
                :field="field"
                :value="data[field.name]"
                @click="$emit('rowClicked')"
                class="data-column"
                v-bind:key="field.name"
                v-for="field in fields"
        />
        <td class="data-column">
            <div class="uk-flex uk-flex-none">
                <a
                        @click="editData()"
                        action="edit"
                        class="uk-icon-button uk-margin-small-right"
                        uk-icon="pencil"
                        v-if="updateEnabled"
                ></a>
                <ActionsButton :actions="this.actions" v-if="this.actions.length >0" :ids="[id]"></ActionsButton>

                <a
                        @click="deleteData()"
                        action="delete"
                        class="uk-icon-button uk-button-danger uk-color-light uk-margin-small-left"
                        uk-icon="trash"
                ></a>
            </div>
        </td>
    </tr>
</template>
<style lang="scss">
    .data-column {
        max-width: 25vw;
    }

</style>

<script>
    import TableColumnData from "./TableColumnData.vue";
    import UIkit from "uikit";
    import Utils from "../../utils";
    import EventBus from "../../event-bus.js";
    import ActionsButton from "../settings/ActionsButton"

    const axios = require("axios/index");
    export default {
        props: [
            "id-field",
            "fields",
            "data",
            "selected",
            "actions",
            "model",
            "updateEnabled"
        ],
        components: {TableColumnData, ActionsButton},

        computed: {
            id() {
                return this.data[this.model.idProperty];
            }
        },
        data() {
            return {
                selectedAction: {}
            };
        },

        created() {
            this.selectedAction = this.actions[0];
        },
        methods: {
            selectChange() {
                this.$emit("tableRowSelected", this.data[this.model.idProperty]);
            },
            editData() {
                EventBus.$emit("editData", this.data);
            },
            deleteData() {
                UIkit.modal
                    .confirm("Are you sure that you want to delete this item?", {
                        labels: {
                            ok: "Yes",
                            cancel: "Cancel"
                        },
                        stack: true
                    })
                    .then(
                        () => {
                            axios({
                                method: "delete",
                                url:
                                    Utils.url +
                                    this.model.path +
                                    "/" +
                                    this.data[this.model.idProperty]
                            })
                                .then(response => {
                                    EventBus.$emit("updateData");
                                    Utils.displayResponse(response);
                                })
                                .catch(function (error) {
                                    Utils.displayError(error);
                                });
                        },
                        function () {
                        }
                    );
            }
        }
    };
</script>
